import React, {Component} from 'react';
import {connect} from 'react-redux';

import AsyncTypeahead from "./AsyncTypeahead.jsx";

import api from '../../../../api.js';

class FonctionTypeahead extends Component {
  search = async (query) => {
    return (await api.fonctions.suggest({
      search: query,
      universe: this.props.currentUniverseId
    })).data;
  }

  static defaultProps = {
    ...AsyncTypeahead.defaultProps,
    promptText: 'Entrez le nom de vos fonctions / metiers'
  }

  render() {
    const {labelKey, valueField, type, customOnChange, ...rest} = this.props;

    return (
      <AsyncTypeahead
        selected={(this.props.input.value ? this.props.input.value : [])}
        onSearch={this.search}
        allowNew={true}
        multiple
        labelKey="name"
        customOnChange={customOnChange}
        {...rest} />
    );
  }
}

export default connect(
  (state) => ({
    currentUniverseId: state.universe?.currentUniverse.id ?? null
  })
)(FonctionTypeahead);